module.exports = {
  BASE_URL: 'https://mirconcreteblock.com/dev/api',
  MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
